import {
  CHANNEL_NAME_PARAM,
  PurchaseChannel,
} from "@redotech/redo-model/warranties";
import { assertNever } from "@redotech/util/type";
import { memo, useMemo } from "react";
import { EmailLink } from "./email-link";

const purchaseChannelToTitle: Record<PurchaseChannel, string> = {
  [PurchaseChannel.ONLINE]: "Let's find your order",
  [PurchaseChannel.RETAIL]: "Let's verify your email",
};

function getPurchaseChannelNextUrl(
  purchaseChannel: PurchaseChannel,
  redirectRegistrationToRetailActions?: boolean,
): string {
  switch (purchaseChannel) {
    case PurchaseChannel.ONLINE:
      return "/returns-portal/orders/register";
    case PurchaseChannel.RETAIL:
      return redirectRegistrationToRetailActions
        ? "/returns-portal/retail"
        : "/returns-portal/retail/register";
    default:
      assertNever(purchaseChannel);
  }
}

function constructNextUrl(
  purchaseChannel: PurchaseChannel,
  channelName: string,
  redirectRegistrationToRetailActions?: boolean,
) {
  const urlParams = new URLSearchParams();
  urlParams.set(CHANNEL_NAME_PARAM, channelName);
  const nextUrl = getPurchaseChannelNextUrl(
    purchaseChannel,
    redirectRegistrationToRetailActions,
  );
  return `${nextUrl}?${urlParams}`;
}

export const RegisterOtp = memo(function RegisterOtp({
  onBack,
  purchaseChannel,
  channelName,
  redirectRegistrationToRetailActions,
}: {
  onBack: () => void;
  purchaseChannel: PurchaseChannel | undefined;
  channelName: string;
  redirectRegistrationToRetailActions?: boolean;
}) {
  const nextUrl = useMemo(() => {
    if (!purchaseChannel) {
      return;
    }
    return constructNextUrl(
      purchaseChannel,
      channelName,
      redirectRegistrationToRetailActions,
    );
  }, [purchaseChannel, channelName, redirectRegistrationToRetailActions]);

  if (!purchaseChannel) {
    return null;
  }

  return (
    <EmailLink
      nextUrl={nextUrl}
      onBack={onBack}
      showFooter={false}
      title={purchaseChannelToTitle[purchaseChannel]}
    />
  );
});
